export default "__VITE_ASSET__DGr6zTwW__"